/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CnyWalletBillItem
 */
export interface CnyWalletBillItem {
    /**
     * 账单ID
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    userId?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    billType?: number;
    /**
     * 账单状态
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    status?: number;
    /**
     * 汇款人（持卡人姓名）
     * @type {string}
     * @memberof CnyWalletBillItem
     */
    cardHolderName?: string;
    /**
     * 客户商业类型：1-企业，2-个人
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    userBusinessType?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof CnyWalletBillItem
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof CnyWalletBillItem
     */
    userCode?: string;
    /**
     * 人民币转账金额
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    totalTransferAmount?: number;
    /**
     * 汇率
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    exchangeRate?: number;
    /**
     * 韩币金额（人民币金额×汇率）
     * @type {number}
     * @memberof CnyWalletBillItem
     */
    krwAmount?: number;
    /**
     * 备注
     * @type {string}
     * @memberof CnyWalletBillItem
     */
    remark?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof CnyWalletBillItem
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof CnyWalletBillItem
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the CnyWalletBillItem interface.
 */
export function instanceOfCnyWalletBillItem(value: object): value is CnyWalletBillItem {
    return true;
}

export function CnyWalletBillItemFromJSON(json: any): CnyWalletBillItem {
    return CnyWalletBillItemFromJSONTyped(json, false);
}

export function CnyWalletBillItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CnyWalletBillItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'status': json['status'] == null ? undefined : json['status'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'userBusinessType': json['userBusinessType'] == null ? undefined : json['userBusinessType'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'krwAmount': json['krwAmount'] == null ? undefined : json['krwAmount'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function CnyWalletBillItemToJSON(json: any): CnyWalletBillItem {
    return CnyWalletBillItemToJSONTyped(json, false);
}

export function CnyWalletBillItemToJSONTyped(value?: CnyWalletBillItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'billType': value['billType'],
        'status': value['status'],
        'cardHolderName': value['cardHolderName'],
        'userBusinessType': value['userBusinessType'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'totalTransferAmount': value['totalTransferAmount'],
        'exchangeRate': value['exchangeRate'],
        'krwAmount': value['krwAmount'],
        'remark': value['remark'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

